import { HttpClient } from '@angular/common/http';
import { ContactUsParams } from 'src/app/contact-us/Models/Request/ContactUsParams';
import { ContactUsResult } from 'src/app/contact-us/Models/Response/ContactUsResult';
import { environment } from "src/environments/environment";
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: "root"
})
export class ContactUsService{
    constructor(
        private http: HttpClient
    ) {

    }

    private ApiEndpoint: string = "/api/Common/ContactUsSendMail";
    
    async SendMessage(ContactUsRequest: ContactUsParams): Promise<ContactUsResult>{
        var result: ContactUsResult;
        try
        {
             result = await this.http.post<ContactUsResult>( environment.endPointsBaseUrl + this.ApiEndpoint, ContactUsRequest).toPromise<ContactUsResult>();
        }
        catch(Exception){
            console.log(Exception);
            result = {
                IsSuccessfull: false,
                Message: "Something went wrong with sending mail. We are working on resolving this issue. Please try again later."
            };
        }
        return result;
    }
}